<template lang="html">
  <v-container fluid style="position: absolute">
    <v-row>
      <v-col cols="12" xs12>
        <v-card class="color-2 ma-4 pa-4">
          <v-row>
            <v-col cols="2" xs2>
              <WorkStepEditorDialog :work_step_editor_dialog="work_step_editor_dialog" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getWorkSteps.length === 0" align="center" justify="center">
      <v-col cols="10" align="center" justify="center">
        <v-alert type="info">
          You don't have any Work Steps yet.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="getWorkSteps.length > 0">
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-model="page"
            :length="Math.ceil(getPagination.total / getPagination.limit)"
            :total-visible="7"
            circle
            @input="changePage($event)"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="getWorkSteps.length > 0">
      <v-col cols="12" xs12>
        <v-card class="color-2 ma-4 pa-4">
          <v-row>
            <v-col :cols="getCols()" v-for="work_step in getWorkSteps" :key="work_step.id">
              <v-card class="color-3 pa-2">
                <v-row>
                  <v-col cols="12">
                    <WorkStepHeaderDetails :work_step="work_step" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    {{work_step.text}}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <StandardOwnerDetails :owner="work_step.owner" />
                  </v-col>
                  <v-col cols="4">
                      <CommunitySuggestBtn class="pull-right" :el="work_step" @communitSuggestClick="suggestWSToCommunity(work_step)" />
                      <StandardDeleteBtn btnclass="pull-right" :el="work_step" @deleteClick="deleteWS(work_step)" />
                      <WorkStepUpdateEditorDialog :work_step="work_step" />
                    <div class="clear"></div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getWorkSteps.length > 0">
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-model="page"
            :length="Math.ceil(getPagination.total / getPagination.limit)"
            :total-visible="7"
            circle
            @input="changePage($event)"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from '@/store/index';
import {
  mapGetters,
  mapActions
} from 'vuex';
import WorkStepEditorDialog from '@/components/WorkSteps/WorkStepEditorDialog.component.vue'
import WorkStepUpdateEditorDialog from '@/components/WorkSteps/WorkStepUpdateEditorDialog.component.vue'
import WorkStepHeaderDetails from '@/components/WorkSteps/WorkStepHeaderDetails.component.vue'
import StandardOwnerDetails from '@/components/StandardComponents/StandardOwnerDetails.component.vue'
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue'
// import StandardEditBtn from '@/components/StandardComponents/StandardEditBtn.component.vue'
import CommunitySuggestBtn from '@/components/Community/CommunitySuggestBtn.component.vue'
export default {
  name: 'CustomWorkStep',
  components: {
    WorkStepEditorDialog,
    WorkStepUpdateEditorDialog,
    WorkStepHeaderDetails,
    StandardOwnerDetails,
    StandardDeleteBtn,
    // StandardEditBtn,
    CommunitySuggestBtn
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('WorkStep/requestCustomWorkSteps').then(res => next(res));
  },
  data: function() {
    return {
      page: 1,
      work_step_editor_dialog: false
    }
  },
  created() {
    if (this.$route.query.editor) {
      this.work_step_editor_dialog = true;
    }
  },
  computed: {
    ...mapGetters('WorkStep', [
      'getWorkSteps',
      'getPagination',
      'isLoading'
    ])
  },
  methods: {
    ...mapActions('WorkStep', [
      'suggestToCommunity',
      'requestCustomWorkSteps',
      'deleteWorkStep'
    ]),
    changePage(page){
      this.page = page;
      this.requestCustomWorkSteps(page);
    },
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    },
    suggestWSToCommunity(work_step){
      this.suggestToCommunity(work_step.id);
    },
    deleteWS(work_step){
      this.deleteWorkStep(work_step.id);
    }
  }
}
</script>

<style lang="css" scoped>
</style>
